import styles from './styles.module.less';

export function EmptyContent() {
	return (
		<div className={styles.noDataWrapper}>
			<div className={styles.noData}>All students have already been added to the assignment.</div>
		</div>
	);
}
